var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zj-layout-container',[_c('zj-layout-main',[_c('div',{ref:"container",staticClass:"zj-layout-main-content bgcolor scrollable"},[_vm._v(" 人脸 ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }